export default "__VITE_ASSET__r$5HZ35Y__"